import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PChipGroupComponent } from './p-chip-group.component';
import { PChipModule } from '../../p-chip';
import { PButtonModule } from '@panaya/ui/p-button';

@NgModule({
    declarations: [PChipGroupComponent],
    imports: [CommonModule, PChipModule, PButtonModule],
    exports: [PChipGroupComponent]
})
export class PChipGroupModule {}
